export const certificationStatus = ['ACTIVE', 'EXPIRED', 'IN_PROGRESS'];
export const EXPIRING_SOON_NOTICE_IN_DAYS = 90;